import { Observable } from 'rxjs/Observable';
import { Constant, BaseComponent, DatePickerFormatter } from '../../../../../../infrastructure/common';
import { Component, AfterViewInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgModel, NgForm } from '@angular/forms';
import { ConfirmationService } from 'primeng/primeng';
import * as moment from 'moment';

import { AnnouncementService, AnnouncementStatusService } from 'app/infrastructure/services/transaction/op/announcement';
import { OnlineOrderService } from '../../../../../../infrastructure/services/transaction/op/outbound/order';

declare var jQuery: any;

@Component({
    selector: 'page-announcement-details',
    templateUrl: './announcement-details.html',
    styleUrls: [`./announcement-details.css`]
})

export class AnnouncementDetailsComponent extends BaseComponent implements AfterViewInit {

    @ViewChild(NgForm) frmAnn: NgForm;
    @ViewChild('txtAnnCode') txtAnnCodeModel: NgModel;

    announcement: any = {};
    announcementStatus: any[];
    owners: any[];
    statusCodes: any[];
    selectedStatus: any = {};

    isEdit: boolean = false;
    isLoading: boolean = false;
    isLoadingDelete: boolean = false;
    isLoadingStatusList: boolean = false;
    isLoadingOwnerList: boolean = false;
    isPermanentDelete: boolean = false;
    isDeleted: boolean = false;

    msgTxtAnnCode: String;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private confirmationService: ConfirmationService,
        private announcementService: AnnouncementService,
        private announcementStatusService: AnnouncementStatusService,
        private onlineOrderService: OnlineOrderService) {
            super();
        }

    ngOnInit(): void {
        let self = this;

        this.activatedRoute.queryParams.subscribe(params => {
            self.announcement['Id'] = params['id'] ? params['id'] : 0;
            self.isEdit = self.announcement['Id'] > 0;

            // load data
            let promiseList = [
                self.getAnnouncementStatusList(),       // load Announcement Status list
                self.getOwnerList()                     // load Owner list
            ];
            Promise.all(promiseList).then(() => {
                if (self.isEdit) {
                    self.getAnnouncement();
                }
                else {
                    self.resetFormData();
                    self.getNewAnnouncement();
                }
            });
        });
    }

    ngAfterViewInit(): void {
        let self = this;

        jQuery(document).ready(() => {
            jQuery('#txtContent').summernote({
                tabsize: 2,
                height: 300,
                toolbar: [
                    ['style', ['style', 'bold', 'italic', 'underline', 'clear']],
                    ['font', ['strikethrough', 'superscript', 'subscript']],
                    ['para', ['ul', 'ol']],
                    ['insert', ['link', 'table', 'hr', 'picture']],
                    ['edit', ['undo', 'redo']],
                    ['misc', ['fullscreen', 'help']]
                ],
                // popover: {
                //     image: [
                //         ['remove', ['removeMedia']]
                //     ],
                // }
            });
        });

        jQuery('#txtContent').on('summernote.change', function(we, contents, $editable) {
            self.announcement.AnnouncementContent = contents;
        });

        jQuery('.mydatepicker').datepicker({
            autoclose: true,
            clearBtn: true,
            format: DatePickerFormatter.mapDateFormat(self.token.DateFormatDescription)
        }).on('change', (e) => {
            let dateFormat: string = self.token.DateFormatDescription.toUpperCase();
            let dateVal: Date = undefined;

            if (e.target.value) {
                dateVal = moment.utc(e.target.value, dateFormat).toDate();
            }
            self.announcement[e.target.name] = dateVal;
        });

        jQuery('#txtFromDate').datepicker().on('change', (e) => {
            let dateFormat: string = self.token.DateFormatDescription.toUpperCase();
            let fromDate: Date;
            let toDate: Date;

            fromDate = (e.target.value) ?
                            moment.utc(e.target.value, dateFormat).toDate() :
                            undefined;
            toDate = (jQuery('#txtToDate').val()) ?
                        moment.utc(jQuery('#txtToDate').val(), dateFormat).toDate() :
                        undefined;

            if (toDate < fromDate) {
                jQuery('#txtToDate').datepicker('setDate', '');
            }

            if (fromDate) {
                jQuery('#txtToDate').datepicker('setStartDate', fromDate);
            }
        });

        setTimeout(() => {
            jQuery('input[name=txtAnnName]').focus();
        });
    }

    getAnnouncementStatusList(): Promise<any> {
        let self = this;
        self.isLoadingStatusList = true;

        return self.executeWebApi(self.announcementStatusService.getAnnouncementStatusByAll()).then(
            message => {
                self.isLoadingStatusList = false;

                self.statusCodes = message.Result;
                if (!self.isEdit) {
                    let defaultStatusCode = self.statusCodes && self.statusCodes.length > 0 ?
                                                self.statusCodes[0].StatusCode :
                                                undefined;
                    self.announcement.Status = defaultStatusCode;
                }
            },
            error => {
                self.isLoadingStatusList = false;
            }
        );

        // let promise = new Promise((resolve, reject) => {
        //     self.isLoadingStatusList = true;

        //     self.announcementStatusService.getAnnouncementStatusByAll().subscribe(
        //         data => {
        //             let message = data;
        //             if (message && message.MessageType && message.MessageType.Value) {
        //                 if (message.MessageType.Value == Constant.MessageType.success) {
        //                     self.statusCodes = message.Result;
        //                     if (!self.isEdit) {
        //                         self.announcement.Status = '1';
        //                     }
        //                 }
        //                 else {
        //                     self.showMessage(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
        //                 }
        //             }
        //             else {
        //                 self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, null);
        //             }
        //         },
        //         error => {
        //             self.isLoadingStatusList = false;
        //             self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
        //             reject();
        //         },
        //         () => {
        //             self.isLoadingStatusList = false;
        //             resolve();
        //         }
        //     );
        // });

        // return promise;
    }

    getOwnerList(): Promise<any> {
        let self = this;
        self.isLoadingOwnerList = true;

        let groupId = self.token.GroupId;
        let isIncludeAll: boolean = true;
        return self.executeWebApi(self.onlineOrderService.getAuthOwnerCustomerReprecentatives(groupId, isIncludeAll)).then(
            message => {
                self.isLoadingOwnerList = false;
                self.owners = message.Result;
                if (!self.isEdit) {
                    let defaultOwnerCode = self.owners && self.owners.length > 0 ?
                                            self.owners[0].OwnerCode :
                                            undefined;
                    self.announcement.OwnerCode = defaultOwnerCode;
                }
            },
            error => {
                self.isLoadingOwnerList = false;
            }
        );

        // let promise = new Promise((resolve, reject) => {
        //     self.isLoadingOwnerList = true;

        //     self.ownerService.getOwnerListByAll(true).subscribe(
        //         data => {
        //             let message = data;
        //             if (message && message.MessageType && message.MessageType.Value) {
        //                 if (message.MessageType.Value == Constant.MessageType.success) {
        //                     self.owners = message.Result;
        //                     if (!self.isEdit) {
        //                         self.announcement.OwnerCode = 'ALL';
        //                     }
        //                 }
        //                 else {
        //                     self.showMessage(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
        //                 }
        //             }
        //             else {
        //                 self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, null);
        //             }
        //         },
        //         error => {
        //             self.isLoadingOwnerList = false;
        //             self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
        //             reject();
        //         },
        //         () => {
        //             self.isLoadingOwnerList = false;
        //             resolve();
        //         }
        //     );
        // });

        // return promise;
    }

    getNewAnnouncement(): Promise<any> {
        let self = this;
        self.isLoading = true;

        return this.executeWebApi(self.announcementService.getNewAnnouncement()).then(
            message => {
                self.isLoading = false;
                self.announcement = message.Result;
            },
            error => {
                self.isLoading = false;
            }
        );

        // let promise = new Promise((resolve, reject) => {
        //     self.isLoading = true;

        //     self.announcementService.getNewAnnouncement().subscribe(
        //         data => {
        //             let message = data;
        //             if (message && message.MessageType && message.MessageType.Value) {
        //                 if (message.MessageType.Value == Constant.MessageType.success) {
        //                     self.announcement = message.Result;
        //                 }
        //                 else {
        //                     self.showMessage(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
        //                 }
        //             }
        //             else {
        //                 self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, null);
        //             }
        //         },
        //         error => {
        //             self.isLoading = false;
        //             self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
        //             reject();
        //         },
        //         () => {
        //             self.isLoading = false;
        //             resolve();
        //         }
        //     );
        // });

        // return promise;
    }

    getAnnouncement(): Promise<any> {
        let self = this;
        self.isLoading = true;

        let id: number = self.announcement['Id'];
        return self.executeWebApi(self.announcementService.getAnnouncementById(id)).then(
            message => {
                self.isLoading = false;
                self.announcement = message.Result;

                self.setFormData();
            },
            error => {
                self.isLoading = false;
            }
        );

        // let promise = new Promise((resolve, reject) => {
        //     self.isLoading = true;

        //     self.announcementService.getAnnouncementById(self.announcement['Id']).subscribe(
        //         data => {
        //             let message = data;
        //             if (message && message.MessageType && message.MessageType.Value) {
        //                 if (message.MessageType.Value == Constant.MessageType.success) {
        //                     self.announcement = message.Result;

        //                     self.isDeleted = (self.announcement['StatusCode'] == 'X');
        //                     if (self.isDeleted) {
        //                         jQuery('#txtContent').summernote('disable');
        //                     }
        //                     else {
        //                         jQuery('#txtContent').summernote('enable');
        //                     }

        //                     jQuery('#txtContent').summernote('code', self.announcement.AnnouncementContent);

        //                     let fromDate: Date = (self.announcement.FromDate) ? new Date(self.announcement.FromDate) : undefined;
        //                     let toDate: Date = (self.announcement.ToDate) ? new Date(self.announcement.ToDate) : undefined;
        //                     jQuery('#txtFromDate').datepicker('setDate', fromDate);
        //                     jQuery('#txtToDate').datepicker('setDate', toDate);
        //                 }
        //                 else {
        //                     self.showMessage(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
        //                 }
        //             }
        //             else {
        //                 self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, null);
        //             }
        //         },
        //         error => {
        //             self.isLoading = false;
        //             self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
        //             reject();
        //         },
        //         () => {
        //             self.isLoading = false;
        //             resolve();
        //         }
        //     );
        // });

        // return promise;
    }

    showDeleteConfirmation() {
        this.isPermanentDelete = false;
        jQuery('#PopupDeleteConfirm').modal('show');
    }

    saveAnnouncement(): void {
        let self = this;
        self.isLoading = true;

        // set default values //
        // new
        if (!self.isEdit) {
            self.announcement.Status = '1';
            self.announcement.CreatedBy = this.token.UserId;
        }
        // edit
        self.announcement.UpdatedBy = this.token.UserId;

        // save
        self.executeWebApi(self.announcementService.saveAnnouncement(self.announcement)).then(
            message => {
                self.isLoading = false;
                self.announcement = message.Result;

                if (self.announcement) {
                    self.showSaveDialog(self.announcement.Code);
                }
            },
            error => {
                self.isLoading = false;
            }
        );

        // // save
        // self.announcementService.saveAnnouncement(self.announcement).subscribe(
        //     data => {
        //         self.isLoading = false;

        //         let message = data;
        //         if (message && message.MessageType && message.MessageType.Value) {
        //             if (message.MessageType.Value == Constant.MessageType.success) {
        //                 self.announcement = message.Result;

        //                 if (self.announcement) {
        //                     self.showSaveDialog(self.announcement.Code);
        //                 }
        //             }
        //             else {
        //                 self.showMessage(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
        //             }
        //         }
        //         else {
        //             self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, null);
        //         }
        //     },
        //     error => {
        //         self.isLoading = false;
        //         self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
        //     }
        // );
    }

    undeleteAnnouncement() {
        let self = this;
        self.isLoadingDelete = true;

        self.announcement.StatusCode = '1';
        self.announcement.UpdatedBy = this.token.UserId;

        self.executeWebApi(self.announcementService.saveAnnouncement(self.announcement)).then(
            message => {
                self.isLoadingDelete = false;
                self.isDeleted = false;
                self.announcement = message.Result;

                jQuery('#txtContent').summernote('enable');
            },
            error => {
                self.isLoadingDelete = false;
            }
        );

        // self.announcementService.saveAnnouncement(self.announcement).subscribe(
        //     data => {
        //         self.isLoadingDelete = false;

        //         let message = data;
        //         if (message && message.MessageType && message.MessageType.Value) {
        //             if (message.MessageType.Value == Constant.MessageType.success) {
        //                 self.announcement = message.Result;
        //                 self.isDeleted = false;

        //                 jQuery('#txtContent').summernote('enable');
        //             }
        //             else {
        //                 self.showMessage(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
        //             }
        //         }
        //         else {
        //             self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, null);
        //         }
        //     },
        //     error => {
        //         self.isLoadingDelete = false;
        //         self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
        //     }
        // );
    }

    deleteAnnouncement(isPermanentDelete: boolean) {
        jQuery('#PopupDeleteConfirm').modal('hide');

        let self = this;
        self.isLoadingDelete = true;

        if (isPermanentDelete) {
            // Permanent delete
            let id: number = self.announcement['Id'];
            self.executeWebApi(self.announcementService.deleteAnnouncement(id)).then(
                message => {
                    self.isLoadingDelete = false;
                    self.showMessage(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
                    self.router.navigate(['pages/new-announcement']);
                },
                error => {
                    self.isLoadingDelete = false;
                }
            );

            // self.announcementService.deleteAnnouncement(self.announcement['Id']).subscribe(
            //     data => {
            //         self.isLoadingDelete = false;

            //         let message = data;
            //         if (message && message.MessageType && message.MessageType.Value) {
            //             self.showMessage(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
            //             self.router.navigate(['pages/new-announcement']);
            //         }
            //         else {
            //             self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError);
            //         }
            //     },
            //     error => {
            //         self.isLoadingDelete = false;
            //         self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
            //     }
            // );
        }
        else {
            // temporarily delete
            self.announcement.StatusCode = 'X';
            self.announcement.UpdatedBy = this.token.UserId;

            self.executeWebApi(self.announcementService.saveAnnouncement(self.announcement)).then(
                message => {
                    self.isLoadingDelete = false;
                    self.announcement = message.Result;
                    self.isDeleted = true;

                    jQuery('#txtContent').summernote('disable');
                },
                error => {
                    self.isLoadingDelete = false;
                }
            );

            // self.announcementService.saveAnnouncement(self.announcement).subscribe(
            //     data => {
            //         self.isLoadingDelete = false;

            //         let message = data;
            //         if (message && message.MessageType && message.MessageType.Value) {
            //             if (message.MessageType.Value == Constant.MessageType.success) {
            //                 self.announcement = message.Result;
            //                 self.isDeleted = true;

            //                 jQuery('#txtContent').summernote('disable');
            //             }
            //             else {
            //                 self.showMessage(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
            //             }
            //         }
            //         else {
            //             self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, null);
            //         }
            //     },
            //     error => {
            //         self.isLoadingDelete = false;
            //         self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
            //     }
            // );
        }
    }

    executeWebApi(fn: Observable<any>): Promise<any> {
        let self = this;
        let promise = new Promise((resolve, reject) => {
            fn.subscribe(
                message => {
                    if (message && message.MessageType && message.MessageType.Value) {
                        if (message.MessageType.Value == Constant.MessageType.success) {
                            resolve(message);
                        }
                        else {
                            self.showMessage(message.MessageType.Value,
                                            message.MessageNumber,
                                            message.Message,
                                            message.AdditionalInformation);
                        }
                    }
                    else {
                        self.showMessage(Constant.MessageType.error,
                                        Constant.MessageNumber.defaultError,
                                        Constant.Message.defaultError,
                                        null);
                    }
                    reject();
                },
                error => {
                    self.showAlert(Constant.MessageType.error,
                                    Constant.MessageNumber.defaultError,
                                    Constant.Message.defaultError, error);
                    reject();
                },
                () => {}
            );
        });

        return promise;
    }

    setFormData(): void {
        let self = this;

        self.isDeleted = (self.announcement['StatusCode'] == 'X');
        if (self.isDeleted) {
            jQuery('#txtContent').summernote('disable');
        }
        else {
            jQuery('#txtContent').summernote('enable');
        }

        jQuery('#txtContent').summernote('code', self.announcement.AnnouncementContent);

        let fromDate: Date = (self.announcement.FromDate) ? new Date(self.announcement.FromDate) : undefined;
        let toDate: Date = (self.announcement.ToDate) ? new Date(self.announcement.ToDate) : undefined;
        jQuery('#txtFromDate').datepicker('setDate', fromDate);
        jQuery('#txtToDate').datepicker('setDate', toDate);
    }

    resetFormData(): void {
        // reset variables
        this.isEdit = false;
        this.isDeleted = false;

        // reset form
        this.frmAnn.resetForm({
            txtOrdering: 1,
            cboOwnerCode: 'ALL',
            cboStatusCode: '1',
        });

        // reset unbound controls
        jQuery('#txtContent').summernote('code', '');
        jQuery('#txtFromDate').datepicker('setDate', '');
        jQuery('#txtToDate').datepicker('setDate', '');
    }

    showSaveDialog(announcementCode: string) {
        let self = this;

        let message = 'Announcement Code: ' + announcementCode + ' has been successfully saved.\n\n' +
          'Would you like to browse Announcement List (Yes) or create new announcement (No)?';

        self.confirmationService.confirm({
            rejectVisible: true,
            icon: Constant.MessageIcon.success,
            header: Constant.MessageType.success,
            message: message,
            accept: () => {
                self.router.navigate(['pages/announcement-list']);
            },
            reject: () => {
                self.router.navigate(['pages/new-announcement']);
                self.resetFormData();
                self.getNewAnnouncement();

                setTimeout(() => {
                    jQuery('input[name=txtAnnName]').focus();
                });
            }
        });
    }

    showMessage(title: string, messageNumber: string, message: string, additionalInfo: string = null) {
        jQuery('#PopupMessageTitle').html(title);
        jQuery('#PopupMessageContent').html('(' + messageNumber + ') ' + message + (additionalInfo ? ' -- ' + additionalInfo : ''));
        jQuery('#PopupMessage').modal('show');
    }

    showAlert(title: string, messageNumber: string, message: string, additionalInfo: string = null) {
        alert(title + ': (' + messageNumber + ') ' + message + '--' + (additionalInfo ? ' -- ' + additionalInfo : ''));
    }

    showDatePicker(idEl) {
        jQuery('#' + idEl).datepicker('show');
    }
}



// WEBPACK FOOTER //
// ./src/app/views/pages/master/op/announcement/announcement-details/announcement-details.component.ts